// NPM Imports
import React from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// JS Imports
//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
import { Button } from 'react-bootstrap'
import { productType } from '../../../types/types'
// Asset Imports
//@ts-ignore
import { OneTimePrice } from '../../../common/types/calculate'

function ProfessionalServicesRow() {
   //TODO: change this to the proper typing once we migrate App.jsx to Typescript
   const state = useQuoteContext()
   const { getString } = state
   const permissions = state.featurePermissions['ProfessionalServices']

   // Filter the product list to get only the Professional Services products with monthly billing frequency sorted by DisplayOrder
   const serviceList = (Object.values(state.product_list) as productType[])
      .filter(
         (product) =>
            product.ProductFamily === 'Professional Services' &&
            product.BillingFreq === 'once',
      )
      .sort(
         (a: productType, b: productType) =>
            (a.DisplayOrder ?? 0) - (b.DisplayOrder ?? 0),
      )

   function onAddService() {
      const updatedList = [
         ...state.professionalServiceDetails,
         { serviceCode: 'None', count: 0 },
      ]
      state.setProfessionalServiceDetails(updatedList)
   }

   if (permissions?.includes(state.user_role)) {
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {getString('product.ProfessionalServicesRow.ProductName')}
            </div>
            <div className='col-bhr2'>
               <Button
                  size='sm'
                  className='add-remove-item-btn'
                  onClick={onAddService}
               >
                  {getString('product.ProfessionalServicesRow.Button')}
               </Button>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.ProfessionalServicesCosts.reduce(
                     (acc: number, val: OneTimePrice) => acc + val.totalPrice,
                     0,
                  ),
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
   }

   return null
}

export default ProfessionalServicesRow
